import * as React from 'react';

import * as S from './styles.sc';

export const Alert: React.FC<
  React.PropsWithChildren<{
    className?: string;
  }>
> = ({ className, children, ...props }) => {
  return (
    <S.Alert className={className} {...props}>
      {children}
    </S.Alert>
  );
};
